<template>
  <div style='width: 100%'>
    <el-autocomplete
      style='width: 100%'
      :debounce='500'
      :fetch-suggestions='querySearch'
      @clear='handleSelect'
      @select='handleSelect'
      clearable
      placeholder='红人检索：输入昵称或平台账号ID'
      v-bind='$attrs'
      v-model='userName'
      v-on='$listeners'
    >
      <template #default='{ item }'>
        <div class='artist-journal-option'>
          <img v-if='item.cover_url' class='avatar' :src='item.cover_url' alt='' />
          <div class='info'>
            <div class='line'>
              <el-tag v-if='item.code' size='mini' type='info'>{{ item.platform_name || item.code }}</el-tag>
              <span class='nickname'>{{ item.nickname }}</span>

            </div>
            <div class='sub'>平台ID：{{ item.account_id || '-' }}</div>
          </div>
        </div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'ArtistJournalSearch',
  props: {
    size: {
      type: String,
      default() {
        return 'mini'
      }
    },
    platformCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      userName: null
    }
  },
  methods: {
    async querySearch(queryString, cb) {
      if (queryString) {
        const { list } = await this.$api.searchArtistPlatform({ keyword: queryString, platform_code: this.platformCode || undefined })
        const result = (list || []).map((item) => {
          item.value = item.nickname
          return item
        })
        cb(result)
      }
    },
    // 处理搜索结果的选中
    handleSelect(item) {
      if (item && item.id) {
        this.$emit('update:artist-id', item.id)
        this.$emit('update:artist-name', item.nickname)
        item.artist_id = item.id
        this.$emit('handleSelect', item)
      } else {
        this.$emit('update:artist-id', null)
        this.$emit('update:artist-name', null)
        this.$emit('handleSelect', null)
      }
    },
    clearSelect: function() {
      this.userName = null
      this.$emit('handleSelect', {})
    },
    clearData() {
      this.userName = null
    }
  }
}
</script>

<style scoped>
.artist-journal-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}

.artist-journal-option .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.artist-journal-option .info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.artist-journal-option .line {
  display: flex;
  align-items: center;
  gap: 6px;
}

.artist-journal-option .nickname {
  font-weight: bold;
}

.artist-journal-option .sub {
  color: #909399;
  font-size: 12px;
}
</style>
